import React from 'react';
import {Datagrid, DateField, List, Pagination, TextField, useTranslate} from 'react-admin';
import {FunctionFilter} from "./d4func_filter";

const FunctionPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]}/>

export const FunctionList = () => {
    const translate = useTranslate();

    return (
        <List
            empty={false}
            filters={<FunctionFilter/>}
            sort={{field: 'modified', order: 'DESC'}}
            exporter={false}
            pagination={<FunctionPagination/>}>
            <Datagrid rowClick="show"
                      bulkActionButtons={false}>
                <TextField
                    label={translate('resources.functions.fields.name')}
                    source="objName"
                />
                <TextField
                    label={translate('resources.functions.fields.type.one')}
                    source="objType"
                />
                <TextField
                    label={translate('resources.functions.fields.scope.one')}
                    source="objScope"
                />
                <DateField
                    label={translate('resources.functions.fields.created')}
                    source="created"
                    showTime
                />
                <DateField
                    label={translate('resources.functions.fields.modified')}
                    source="modified"
                    showTime
                />
            </Datagrid>
        </List>
    );
};
